export const cardGroupLayoutConfig: {
  [key: string]: { xxsColumns: number; mColumns: number; lColumns: number };
} = {
  "Mobile: 1, Tablet: 2, Desktop: 2": {
    xxsColumns: 1,
    mColumns: 2,
    lColumns: 2,
  },
  "Mobile: 1, Tablet: 3, Desktop: 3": {
    xxsColumns: 1,
    mColumns: 3,
    lColumns: 3,
  },
  "Mobile: 2, Tablet: 4, Desktop: 4": {
    xxsColumns: 2,
    mColumns: 4,
    lColumns: 4,
  },
};
